import React from "react";
import { Navigate } from "react-router-dom";
import TailSpinLoader from "../components/TailSpinLoader/TailSpinLoader";

const PermissionGuard = ({ permission, children }) => {
  if (!permission) return children;

  const isPermitted = permission();

  // Handle null (pending) state - show loader
  if (isPermitted === null) {
    return (
      <div
        className="h-100 position-absolute d-flex flex-column align-items-center justify-content-center"
        style={{
          marginRight: "calc(50vw - 100px)",
          right: 0,
          width: "200px",
          gap: "40px",
          top: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <TailSpinLoader />
      </div>
    );
  }

  // Handle true - grant access
  if (isPermitted) {
    return children;
  }

  // Handle false - deny access
  return <Navigate to="/" />;
};

export default PermissionGuard;
